import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from '../images/ggsf_logo.png';
import useAuth from '../context/useAuth';

const NavBar = () => {
  const { username, umemid, token, role } = useAuth();
  const memberId = umemid;

  const promptForReceiptNumber = () => {
    const receiptNumber = prompt("Please enter the receipt number:");
    if (receiptNumber) {
      window.location.href = `/receiptDetails/${receiptNumber}`;
    }
  };

  const promptForMemberIDforHistory = () => {
    const memberID = prompt("Please enter the member account ID:");
    if (memberID) {
      window.location.href = `/donationHistory/${memberID}`;
    }
  };

  const promptForMemberIDforDonation = () => {
    const memberID = prompt("Please enter the member account ID:");
    if (memberID) {
      window.location.href = `/addNewReceipt/${memberID}`;
    }
  };

  const promptForMemberDetailID = () => {
    const memberID = prompt("Please enter the member account ID:");
    if (memberID) {
      window.location.href = `/memberDetails/${memberID}`;
    }
  };

   const promptForMemberMemoID = () => {
    const memberID = prompt("Please enter the member account ID:");
    if (memberID) {
      window.location.href = `/memo-management/${memberID}`;
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light" style={{ backgroundColor: 'lightcyan' }}>
      <div className="container">
        <NavLink className="navbar-brand" to="/">
          <span>
            <img src={logo} alt="logo" height="64px" width="64px" />
          </span>
        </NavLink>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <ul className="navbar-nav ml-auto">
            {token && (
              <li className="nav-item">
                <NavLink className="nav-link" activeStyle={{ color: 'white', backgroundColor: 'blue' }} to="/" exact>
                  Home
                </NavLink>
              </li>
            )}
            {token && role !== 'member' && (
              <>
                <li className="nav-item dropdown">
                  <Link className="nav-link dropdown-toggle" to="#" id="membersDropdown" role="button" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    Members
                  </Link>
                  <div className="dropdown-menu" aria-labelledby="membersDropdown">
                    <NavLink className="dropdown-item" activeStyle={{ color: 'white', backgroundColor: 'blue' }} to="/members" exact>
                      Search Members
                    </NavLink>
                    {(role === 'admin' || role === 'ops') && (
                      <NavLink className="dropdown-item" activeStyle={{ color: 'white', backgroundColor: 'blue' }} to="/addNewMember" exact>
                        Add Member
                      </NavLink>
                    )}
                    <button className="dropdown-item" onClick={promptForMemberDetailID}>
                      Search Member by Member ID
                    </button>
                    <button className="dropdown-item" onClick={promptForMemberMemoID}>
                     Member Memo Maintenance by Member ID
                    </button>
                    <NavLink className="dropdown-item" activeStyle={{ color: 'white', backgroundColor: 'blue' }} to="/memberDonations" exact>
                      Member Donation Report: Lifetime or Last Donation
                    </NavLink>
                    <NavLink className="dropdown-item" activeStyle={{ color: 'white', backgroundColor: 'blue' }} to="/memberDonationsbyYear" exact>
                      Member Donation Summary Report: By Year
                    </NavLink>
                  </div>
                </li>
                <li className="nav-item dropdown">
                  <Link className="nav-link dropdown-toggle" to="#" id="receiptsDropdown" role="button" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    Donations
                  </Link>
                  <div className="dropdown-menu" aria-labelledby="receiptsDropdown">
                    <NavLink className="dropdown-item" activeStyle={{ color: 'white', backgroundColor: 'blue' }} to="/receipts" exact>
                      Search Receipts by Donation Date
                    </NavLink>
                    <NavLink className="dropdown-item" activeStyle={{ color: 'white', backgroundColor: 'blue' }} to="/cardPayments" exact>
                      Search CardPayments by Donation Date
                    </NavLink>
                    <button className="dropdown-item" onClick={promptForReceiptNumber}>
                      Search Receipt by Receipt Number
                    </button>
                    <button className="dropdown-item" onClick={promptForMemberIDforHistory}>
                      Search Receipts by Member ID
                    </button>          
                    <NavLink className="dropdown-item" activeStyle={{ color: 'white', backgroundColor: 'blue' }} to="/depositTicketsList" exact>
                      Search Deposit Ticket by Ticket Date
                    </NavLink>
                    {(role === 'admin' || role === 'ops') && (
                      <button className="dropdown-item" onClick={promptForMemberIDforDonation}>
                        Add Donation Receipt by Member ID
                      </button>
                    )}
                    <NavLink className="dropdown-item" activeStyle={{ color: 'white', backgroundColor: 'blue' }} to="/addNewDepositTicket" exact>
                      Add Deposit Ticket
                    </NavLink>          
                    <NavLink className="dropdown-item" activeStyle={{ color: 'white', backgroundColor: 'blue' }} to="/donations" exact>
                      Donation Report: Year, Quarter, or Month
                    </NavLink> 
                  </div>
                </li>
                {(role === 'admin' || role === 'ops') && (
                  <li className="nav-item dropdown">
                    <Link className="nav-link dropdown-toggle" to="#" id="usersDropdown" role="button" data-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      AppUsers
                    </Link>
                    <div className="dropdown-menu" aria-labelledby="usersDropdown">
                      <NavLink className="dropdown-item" activeStyle={{ color: 'white', backgroundColor: 'blue' }} to="/add-user" exact>
                        Add User
                      </NavLink>
                      <NavLink className="dropdown-item" activeStyle={{ color: 'white', backgroundColor: 'blue' }} to="/user-management" exact>
                        User Management
                      </NavLink>
                    </div>
                  </li>
                )}
                {role === 'admin' && (
                  <li className="nav-item dropdown">
                    <Link className="nav-link dropdown-toggle" to="#" id="adminDropdown" role="button" data-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      Admin
                    </Link>
                    <div className="dropdown-menu" aria-labelledby="adminDropdown">
                      <NavLink className="dropdown-item" activeStyle={{ color: 'white', backgroundColor: 'blue' }} to="/merge-members" exact>
                        Merge Duplicate Members
                      </NavLink>
                      <NavLink className="dropdown-item" activeStyle={{ color: 'white', backgroundColor: 'blue' }} to="/config" exact>
                        Organization Settings
                      </NavLink>
                      <NavLink className="dropdown-item" activeStyle={{ color: 'white', backgroundColor: 'blue' }} to="/audit-user" exact>
                        Audit Records-Users
                      </NavLink>
                      <NavLink className="dropdown-item" activeStyle={{ color: 'white', backgroundColor: 'blue' }} to="/audit-receipt" exact>
                        Audit Records-Receipts
                      </NavLink>
                      <NavLink className="dropdown-item" activeStyle={{ color: 'white', backgroundColor: 'blue' }} to="/audit-member" exact>
                        Audit Records-Members
                      </NavLink>
                      <NavLink className="dropdown-item" activeStyle={{ color: 'white', backgroundColor: 'blue' }} to="/reference-maintenance" exact>
                        Reference Maintenance
                      </NavLink>
                    </div>
                  </li>
                )}
              </>
            )}
            {token && role === 'member' && (
              <React.Fragment>
                <li className="nav-item">
                  <NavLink className="nav-link" activeStyle={{ color: 'white', backgroundColor: 'blue' }} to={`/memberDetails/${memberId}`} exact>
                    My Member Profile
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" activeStyle={{ color: 'white', backgroundColor: 'blue' }} to={`/donationHistory/${memberId}`} exact>
                    My Donations
                  </NavLink>
                </li>
              </React.Fragment>
            )}
             <li className="nav-item">
              {token && (
                
                <NavLink
                  className="nav-link"
                  activeStyle={{ color: 'white', backgroundColor: 'blue' }}
                  to="/userProfile"
                >
                  My Profile
                </NavLink>
              )}
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" activeStyle={{ color: 'white', backgroundColor: 'blue' }} to="/about" exact>
                Contact Us
              </NavLink>
            </li>
            <li className="nav-item">
              {!token && (
                <NavLink className="nav-link" activeStyle={{ color: 'white', backgroundColor: 'blue' }} to="/login">Login</NavLink>
              )}
              {token && (
                
                <NavLink
                  className="nav-link"
                  activeStyle={{ color: 'white', backgroundColor: 'blue' }}
                  to="/logout"
                >
                  Log Out {username ? `(${username})` : '(User)'}
                </NavLink>
              )}
            </li>           
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;